export const getNextPageUrl = (pageNumber) => {
	const query = new URLSearchParams(window.location.search);
	query.set("evPage", pageNumber);

	return `?${query.toString()}`;
};

export function isMobile() {
	return window.matchMedia("not all and (pointer: fine)").matches;
}
